<template>
  <div :class="$style.topBar">
    <div :class="$style.fileInfo">
      <span :class="$style.back" @click="goHome"></span>
      <span
        :class="[
          $style.fileType,
          $style[fileType ? `${fileType}File` : 'unknownFile'],
        ]"
      ></span>
      <div :class="$style.detail">
        <p :class="$style.fileName">{{ fileName }}</p>
        <p :class="$style.update">
          {{ updateBy }}{{ $t("92861a3b7f") }}{{ fileUpdate }}
        </p>
      </div>
    </div>
    <div :class="$style.fn">
      <button
        :class="$style.share"
        class="kButton"
        @click="share"
        v-if="userInfo && $modules.share"
      >
        {{ $t("122ce7bbe9") }}
      </button>
      <button
        :class="$style.login"
        class="kButton"
        @click="login"
        v-if="!userInfo && $modules.login"
      >
        {{ $t("8742930fad") }}
      </button>
      <QRCode :class="$style.qrcode" v-if="userInfo" />
      <TopBarMenu :class="$style.menu" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { format } from 'timeago.js'
import TopBarMenu from '@/components/TopBarMenu'
import QRCode from '@/components/QRCode'
import Emitter from 'element-ui/lib/mixins/emitter'
import { showEntShare } from '@/utils/entShare'

export default {
  name: 'TopBar',
  components: {
    TopBarMenu,
    QRCode
  },
  mixins: [Emitter],
  computed: {
    ...mapState(['fileType', 'fileInfo', 'userInfo']),
    fileName() {
      let filename = ''
      if (this.fileInfo) {
        filename = this.fileInfo.fname.split('.').slice(0, -1).join('.')
      }
      return filename
    },
    fileUpdate() {
      let str = ''
      if (this.fileInfo) {
        str = format(this.fileInfo.mtime * 1000, 'zh_CN')
      }
      return str
    },
    updateBy() {
      if (this.fileInfo.modifier && this.fileInfo.modifier.name)
        return this.fileInfo.modifier.name
      if (this.fileInfo.user_nickname) return this.fileInfo.user_nickname
      return ''
    }
  },
  methods: {
    goHome() {
      window.location.href = 'https://docs.wps.cn'
    },
    async share() {
      try {
        return await showEntShare({
          fileId: +this.fileInfo.fileid,
          position: 'mediaPreviewNewTopBar'
        })
      } catch (e) {
        // 企业分享 V4 弹窗失败，走旧的分享弹窗
        console.dir(e)
      }

      this.kdialog.show('fileShare', {
        id: +this.fileInfo.fileid,
        isClink: true,
        // lc链接已支持免登录查看
        fname: this.fileInfo.fname,
        groupid: +this.fileInfo.groupid
      })
    },
    login() {
      let loginUrl = `https://account.wps.cn/?cb=${encodeURIComponent(
        location.href
      )}`
      window.location.href = loginUrl
    }
  }
}
</script>
<style lang="scss" module>
.topBar {
  height: 49px;
  border-bottom: 1px solid #dadada;
  box-sizing: border-box;
  background: #fafafa;
  display: flex;
}

.fileInfo {
  flex: 1;
  display: flex;
  padding-left: 14px;
  align-items: center;
  width: 50%;
}

.fn {
  flex: 1;
  display: flex;
  padding-right: 16px;
  align-items: center;
  justify-content: flex-end;
}

.back {
  display: inline-block;
  width: 28px;
  height: 28px;
  box-sizing: border-box;
  background: url(./assets/back.svg) no-repeat 50%;
  cursor: pointer;

  &:hover {
    border: 1px solid #e2e2e2;
  }
}

.detail {
  margin-left: 12px;
  max-width: calc(100% - 102px);
}

.fileName {
  font-size: 14px;
  color: #383838;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: normal;
}

.update {
  font-size: 12px;
  color: #999;
  margin: 0;
}

.fileType {
  width: 30px;
  height: 30px;
  margin-left: 18px;
  background-position: 50%;
  background-repeat: no-repeat;
}

.videoFile {
  background-image: url(./assets/video_file_icon.svg);
}

.audioFile {
  background-image: url(./assets/audio_file_icon.svg);
}

.unknownFile {
  background-image: url(./assets/unknown_file_icon.svg);
}

.share,
.login {
  width: 66px;
  height: 28px;
}

.qrcode {
  margin-left: 8px;
  cursor: pointer;
}

.menu {
  margin-left: 8px;
  cursor: pointer;
}
</style>
